import type { DataTableColumnMeta } from 'components/tables/data-table';

/** Column id resolution, matching what the table engine derives when a def leaves `id` out:
 *  explicit `id`, else a string `accessorKey`, else a string `header`. Columns with none are
 *  skipped by the picker. */
export const getColumnId = (column: object): string | undefined => {
    const { id, accessorKey, header } = column as { id?: unknown; accessorKey?: unknown; header?: unknown };
    if (typeof id === 'string') return id;
    if (typeof accessorKey === 'string') return accessorKey;
    if (typeof header === 'string' && header) return header;
    return undefined;
};

/** A column's layout / totals / sort meta, defaulted to an empty (inert) object so a caller can
 *  destructure it without a null check. */
export const getColumnMeta = (column: object): DataTableColumnMeta =>
    ((column as { meta?: DataTableColumnMeta }).meta ?? {}) as DataTableColumnMeta;
